var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('DebounceInput',{attrs:{"label":_vm.$t('SYSTEM_EMAIL'),"clearable":"","type":"email"},on:{"change":_vm.changed},model:{value:(_vm.filters.mail),callback:function ($$v) {_vm.$set(_vm.filters, "mail", $$v)},expression:"filters.mail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }